import { collection, doc, onSnapshot } from "firebase/firestore"
import { motion } from "framer-motion"
import LottiePlayer from "lottie-react"
import { useEffect, useLayoutEffect, useState } from "react"
import { FiBell, FiMoon, FiUser } from "react-icons/fi"
import { MdClose, MdDone } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import { useRecoilState, useSetRecoilState } from "recoil"
import loadingAnimation from "../animations/loader.json"
import placeholder from "../assets/place.webp"
import { productAtom } from "../atoms/auth"
import configAtom from "../atoms/configAtom"
import BottomNav from "../components/BottomNav"
import { auth, db } from "../functions/firebase"
import "./homescreen.css"
// import menu from "./menu.json"

export default function HomeScreen() {

    const navigate = useNavigate()
    const setProduct = useSetRecoilState(productAtom)
    const [cat, setCat] = useState("Water")
    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark")
    const [menu, setMenu] = useState([])
    const [config, setConfig] = useRecoilState(configAtom)
    const online = (config?.allowCollect || config?.allowDelivery)

    const [pageHeight, setPageHeight] = useState("calc(100vh - 100px)")

    useLayoutEffect(() => { 

        const h = document.getElementById("headerwrapper")?.getBoundingClientRect()?.height

        if(h) {
            setPageHeight(`calc(100vh - ${h}px)`)
        }

    }, [menu])

 

    useEffect(() => {

        return onSnapshot(doc(db, `admin/settings`), {
            next: d => {

                const data = d.data()
                setConfig(data)

            }
        })

    }, [])

    useEffect(() => {

        return onSnapshot(collection(db, "services"), { includeMetadataChanges: true }, {
            next: d => {

                const docs = d.docs.map(c => ({ ...c.data(), id: c.id })).filter(itm => {
                    return itm?.services?.length > 0 && itm.title.toLowerCase() !== "retail"
                })
                
                if(d.size > 0) {
                    localStorage.setItem("data", JSON.stringify(docs))
                }
                setMenu(docs.reverse())
                
            },
            error: () => {
                const services = localStorage.getItem("data")
                if(services) {
                    setMenu(JSON.parse(services))
                }
            }
        })

    }, [])

    function toogleMoon() {

        const html = document.getElementsByTagName("html")
        const theme = localStorage.getItem("theme")
        const newTheme = (!theme || theme === "dark") ? "light" : "dark"

        if(window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(newTheme)
        }

        for(const doc of html) {
            doc.setAttribute("theme", newTheme)
            localStorage.setItem("theme", newTheme)
            setTheme(newTheme)
        }

    }

    if(menu.length === 0) {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                width: '100vw',
                height: "100vh",
                backgroundColor: 'var(--background)',
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <LottiePlayer 
                    animationData={loadingAnimation}
                    loop={true}
                    style={{
                        width: 200,
                    }}
                />
            </div>
        )
    }
   
    return (
        <>

            <div className="headerWrapper row spaceBetween centerX" style={{ padding: 10, backgroundColor: "var(--header)", position: "sticky", top: 0, zIndex: 2000 }} id="headerwrapper">
                <select name="Categories" value={cat} onChange={e => {

                    const doc = document.getElementById(e.target.value.replace(" ", ""))
                    // setCat(e.target.value)
                    if(doc) {
                        
                        const top = doc.getBoundingClientRect()
                        const docs = document.getElementById("homePage")
                        docs.scrollBy({ top: top.top - 100, behavior: "smooth" })
                    }

                    
                }} id="cats" 
                    style={{
                        borderRadius: 100,
                        margin: 0,
                        width: "50vw"
                    }}
                >
                    {menu?.map(item => <option value={item.title} key={item.title}>{item.title}</option>)}
                </select>
                <div className="row centerX">
                    <div className="center" onClick={toogleMoon} style={{ width: 50, aspectRatio: 1 }}>
                        <FiMoon size={25} color={theme !== "light" ? "var(--primary)" : "var(--text)"} />
                    </div>
                    <div className="center" onClick={() => navigate(`/auth-1/${auth?.currentUser?.uid}/notifications`)} style={{ width: 50, aspectRatio: 1 }}>
                        <FiBell size={25}  />
                    </div>
                    <div className="center" onClick={() => navigate(`/auth-1/${auth?.currentUser?.uid}/configuration`)} style={{ width: 50, aspectRatio: 1 }}>
                        <FiUser size={25}  />
                    </div>
                    {window.innerWidth > 480 && <BottomNav home disabled={!online} />}
                </div>
            </div>
            <div id="homePage" onScroll={(e) => {

                const a = document.getElementsByClassName("anchor")

                for (const b of a) {
                    if(b.getBoundingClientRect().top < (window.innerWidth / 4) && b.getBoundingClientRect().top > 0) {
                        setCat(b.innerHTML)
                    }
                }

            }} style={{ height: pageHeight }}>

                <div className="row centerX" style={{  gap: 20, padding: "10px", backgroundColor: "#D9993725" }}>
                    <div className="row centerX" style={{ padding: "5px 10px", borderRadius: 50, flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                        <p style={{ textAlign: 'center' }}>
                            {config?.allowCollect ? "" : 'No '}Collect
                        </p>
                        {config?.allowCollect ? <MdDone size={25} /> : <MdClose size={25} />}
                    </div>
                    <div className="row centerX" style={{ padding: "5px 10px", borderRadius: 50, flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                        <p style={{ textAlign: 'center' }}>
                            {config?.allowDelivery ? "" : 'No '}Delivery 
                        </p>
                        {config?.allowDelivery ? <MdDone size={25} /> : <MdClose size={25} />}
                    </div>
                </div>

                {/* <p style={{ textAlign: "center", padding: 10, color: "red" }}>Service Fee now R1 for collect and R2 for delivery</p> */}
                
                <motion.div 
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    style={{ overflow: "visible" }}
                >
                    {menu.map(c => (
                        <div key={c.id}>
                            <div id={c.title.replace(" ", "")}  />
                            <div style={{ width: "80%", margin: "10px auto" }}>
                            <p className="anchor" style={{ fontWeight: "bold", fontSize: 25, textAlign: 'center' }}>{c.title}</p>
                            </div>
                            <div  id="gridWrapper">
                                {c?.services.map((val, i) => (
                                    <motion.div
                                        className="itemWrapper" 
                                        onClick={() => {

                                            if(!val.show) return  window.alert("Sorry, This item is currently not available")

                                            if(!config?.allowCollect && !config?.allowDelivery) {
                                                return window.alert("Sorry we are currently not taking orders.")
                                            }

                                            setProduct({
                                                ...val,
                                                sources: [],
                                                quantity: 1,
                                                mainTitle: c.title
                                            })
                                            navigate("/auth-1/" + (auth.currentUser?.uid || "user") + "/product")
                                        }} 
                                        key={val.title + "-" + i + "-item"}
                                    >
                                        <div>
                                            <img className="servicePhoto" src={val?.images && val?.images[0] ? val?.images[0]?.uri : placeholder} alt="" />
                                        </div>
                                        <div style={{ padding: "0 15px 15px 15px" }}>
                                            <p style={{ color: "grey", fontSize: "medium" }}>{val.title}</p>
                                            <p style={{ fontSize: 12, color: val.show ? "green" : "red" }}>{!val.show ? "Not available" : "Available"}</p>
                                            <h1 style={{ fontSize: 22, marginTop: 5, color: "#000" }}>
                                            R {val.price}
                                            </h1>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    ))}
                </motion.div>
                <div style={{ height: 200, width: 20 }} />
            </div>

            <motion.div 
                animate={{ 
                    y: !online ? 0 : 500
                }}
                style={{
                    backgroundColor: "var(--primary)",
                    padding: "10px 5px",
                    margin: "0 20px 15px 20px",
                    position: "fixed",
                    bottom: window.innerWidth <= 480 ? 90 : 20,
                    width: "calc(100vw - 50px)"
                }}>
                    <p style={{ color: "#000", textAlign: "center", color: "white" }}>Sorry, There is no delivery at the moment, Try going to the store</p>
                </motion.div>
                

            {window.innerWidth <= 480 && <BottomNav home disabled={!online} />}
        </>
    )
}